import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Typography } from "@tino-frontend/coreui";
import { Wrapper, Form, EachMock, Label, Hr, Buttons } from "./select-mock.styles.js";
import { getListMock, addListMock, setActiveMock, clear } from "../../services/service.js";
function SelectMockComponent(props) {
  const { mockDebugList } = props;
  const [listMock, setListMock] = useState(
    {}
  );
  useEffect(() => {
    const mocksParsed = getListMock();
    setListMock(mocksParsed);
  }, []);
  useEffect(() => {
    addListMock(listMock);
  }, [listMock]);
  function handleSelect(event, mock) {
    const selectValue = event.target.value;
    const copyListMock = JSON.parse(JSON.stringify(listMock));
    if (selectValue === "") {
      delete copyListMock[mock.title];
    } else {
      copyListMock[mock.title] = selectValue;
    }
    setActiveMock();
    setListMock(copyListMock);
  }
  function onDeactivateAllMocks() {
    clear();
    location.reload();
  }
  function optionSelected(mockTitle) {
    return listMock[mockTitle];
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Wrapper, { children: mockDebugList.map((mocks) => {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "body1", fontWeight: "bold", pb: 1, children: mocks.title }),
        mocks.type === "callback" ? /* @__PURE__ */ jsx(Form, { children: mocks.list.map((mock) => /* @__PURE__ */ jsxs(EachMock, { children: [
          /* @__PURE__ */ jsx(Label, { children: mock.title }),
          mock.options.map(
            (option) => /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                onClick: option.callback,
                children: option.id
              },
              option.id
            )
          )
        ] }, `each-mock-${mock.title}`)) }) : /* @__PURE__ */ jsx(Form, { children: mocks.list.map((mock) => /* @__PURE__ */ jsxs(EachMock, { children: [
          /* @__PURE__ */ jsx(Label, { children: mock.title }),
          /* @__PURE__ */ jsxs(
            "select",
            {
              name: "mock-debug",
              id: `select-mock-debug-${mock.title}`,
              onChange: (e) => handleSelect(e, mock),
              style: { width: "100%" },
              value: optionSelected(mock.title),
              children: [
                /* @__PURE__ */ jsx("option", { value: "", children: "-" }),
                mock.options.map(
                  (option) => /* @__PURE__ */ jsx("option", { value: option.id, children: option.title }, option.id)
                )
              ]
            }
          )
        ] }, `each-mock-${mock.title}`)) }),
        /* @__PURE__ */ jsx(Hr, {})
      ] }, mocks.title);
    }) }),
    /* @__PURE__ */ jsxs(Buttons, { children: [
      /* @__PURE__ */ jsx("button", { onClick: () => location.reload(), children: "page reload" }),
      /* @__PURE__ */ jsx("button", { onClick: () => onDeactivateAllMocks(), children: "deactivate mocks" })
    ] })
  ] });
}
export {
  SelectMockComponent
};
//# sourceMappingURL=select-mock.component.js.map
